
export const Colors = {
    gray0: '#f3f4f5',
    gray1: '#dde0e2',
    gray2: '#c7cdcf',
    gray3: '#b1b9bc',
    gray4: '#9ba5a9',
    gray5: '#859196',
    gray6: '#6e7e82',
    gray7: '#586a6f',
    gray8: '#42565c',
    gray9: '#2c4249',
    gray10: '#162f36',
    gray11: '#001b23',

    purple0: '#fcefff',
    purple1: '#e3c7f2',
    purple2: '#c99fe4',
    purple3: '#b077d7',
    purple4: '#964fc9',
    purple5: '#7d27bc',
    purple6: '#6e21aa',
    purple7: '#5e1a97',
    purple8: '#4f1385',
    purple9: '#400d72',
    purple10: '#300760',
    purple11: '#21004d',

    pink0: '#fff0f4',
    pink1: '#fbc3dd',
    pink2: '#f896c6',
    pink3: '#f468ae',
    pink4: '#f03b97',
    pink5: '#d53387',
    pink6: '#b92a76',
    pink7: '#9e2266',
    pink8: '#831956',
    pink9: '#681146',
    pink10: '#4c0835',
    pink11: '#310025',

    red0: '#fff1ed',
    red1: '#fac3c0',
    red2: '#f59694',
    red3: '#ef6867',
    red4: '#ea3a3a',
    red5: '#d03234',
    red6: '#b7292d',
    red7: '#9d2127',
    red8: '#831920',
    red9: '#69111a',
    red10: '#500813',
    red11: '#36000d',

    orange0: '#fff2d9',
    orange1: '#fed5a7',
    orange2: '#fcb875',
    orange3: '#fb9b43',
    orange4: '#e2893b',
    orange5: '#c87732',
    orange6: '#af652a',
    orange7: '#965322',
    orange8: '#7c4019',
    orange9: '#632e11',
    orange10: '#491c08',
    orange11: '#300a00',

    yellow0: '#fff883',
    yellow1: '#fce85a',
    yellow2: '#f8d830',
    yellow3: '#e0c22b',
    yellow4: '#c8ac25',
    yellow5: '#b19620',
    yellow6: '#99801b',
    yellow7: '#816b15',
    yellow8: '#695510',
    yellow9: '#523f0b',
    yellow10: '#3a2905',
    yellow11: '#221300',

    green0: '#ecffdb',
    green1: '#daffba',
    green2: '#c3ed96',
    green3: '#acdc72',
    green4: '#95ca4e',
    green5: '#85b444',
    green6: '#759e3b',
    green7: '#658831',
    green8: '#557227',
    green9: '#455c1d',
    green10: '#354613',
    green11: '#25300a',

    blue0: '#ebf5ff',
    blue1: '#b1e2f7',
    blue2: '#78d0ef',
    blue3: '#3ebde6',
    blue4: '#04aade',
    blue5: '#0396c2',
    blue6: '#0381a6',
    blue7: '#026d8a',
    blue8: '#02586e',
    blue9: '#014452',
    blue10: '#012f36',
    blue11: '#001b1a'
};

export const clusterColorScheme = [
    { major: Colors.blue2, minor: Colors.blue3 },
    { major: Colors.green3, minor: Colors.green4 },
    { major: Colors.yellow1, minor: Colors.yellow2 },
    { major: Colors.orange2, minor: Colors.orange3 },
    { major: Colors.red2, minor: Colors.red3 },
    { major: Colors.pink2, minor: Colors.pink3 },
    { major: Colors.purple2, minor: Colors.purple3 }
];
